module.exports = __webpack_public_path__ + "img/symbol_4.75c9f502.png";